import moment from 'moment';
const dateFormatMap = {
  '': 'YYYY-MM-DD',
  'yyyy-MM-dd': 'YYYY-MM-DD',
  yyyy: 'YYYY',
  'yyyy-MM': 'YYYY-MM',
  'yyyy-MM-dd HH:mm:ss': 'YYYY-MM-DD HH:mm:ss',
  'yyyy-MM-dd hh:mm:ss': 'YYYY-MM-DD hh:mm:ss'
};
export const validatorValue = (rule, value, callback) => {
  if (Array.isArray(value)) {
    if (value.length < 1) {
      callback(new Error('不能为空'));
    }
    callback();
  } else {
    if (!value) {
      callback(new Error('不能为空'));
    }
    callback();
  }
};

export const getFormatConditionData = (conditionData) => {
  const result = conditionData.map(item => {
    const newItem = item.map(i => {
      const { value, ...rest } = i;
      return {
        ...rest,
        value: i.type == 'date' ? moment(value).format(dateFormatMap[i.dateFormat]) : value
      };
    });
    return newItem;
  });
  return result;
};
